import component from "*.vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/Login",
    name: "Login",
    component: () => import("../views/Login.vue"),
  },
  {
    path: "/Register",
    name: "Register",
    component: () => import("../views/Register.vue"),
  },
  {
    path: "/Blog/:name",
    name: "Blog",
    component: () => import("../views/Blog.vue"),
  },
  {
    path: "/About",
    name: "About",
    component: () => import("../views/About.vue"),
  },
  {
    path: "/Customer",
    name: "Customer",
    component: () => import("../views/Customer.vue"),
    children:[
      {
        path:"/",
      component:()=>import("../components/Customer/Profile.vue")
    },
    {
      path:"/Customer/Profile",
    component:()=>import("../components/Customer/Profile.vue")
  },
      {
        path:"/Customer/Trend",
        name:"trend",
        component:()=>import("../components/Customer/Trend.vue")
      },
      {
        path:"/Customer/Content",
        name:"content",
        component:()=>import("../components/Customer/Content.vue")
      },
      {
        path:"/Customer/Video",
        name:"video",
        component:()=>import("../components/Customer/Video.vue")
      },
{
        path:"/Customer/Video/:name",
        name:"custvideo",
        component:()=>import("../components/Customer/VideoPlay.vue")
      }
    ]
  },
  {
    path:"/unauthorized",
    name:'unauth',
    component:()=>import("../views/UnAuthorized.vue"),
  },
 {
    path:"/:catchAll(.*)",
    component:()=>import("../views/UnderDevelopment.vue"),
  },
 
  
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});
import UserApi from '@/services/api/UserApi'
router.beforeEach((to,from,next)=>{
  //next()
  if(to.name=='trend' ) {
    UserApi.getPermission().then((resp:any)=>{
      if(resp.data.trend==true)
      {
        next()
      }
      else
      {
        next({name:'unauth'})
      }
      //console.log('guard')
    }).catch((e)=>{
      //console.log('error1')
      next({name:'unauth'})
    })
  }
  else if(to.name=='video' ) {
    UserApi.getPermission().then((resp:any)=>{
      if(resp.data.video==true)
      {
        next()
      }
      else
      {
        next({name:'unauth'})
      }
      //console.log('guard')
    }).catch((e)=>{
      //console.log('error1')
      next({name:'unauth'})
    })
  }
  else if(to.name=='content' ) {
    UserApi.getPermission().then((resp:any)=>{
      if(resp.data.content==true)
      {
        next()
      }
      else
      {
        next({name:'unauth'})
      }
      //console.log('guard')
    }).catch((e)=>{
      //console.log('error1')
      next({name:'unauth'})
    })
  }
    else 
    {
      next()
    }

})
export default router;
